import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

interface StepCheckResponse {
    registered: boolean;
    current_step: number;
    step:number;
}

export function useRegistrationStep(participantId?: number, periodId?: number) {
    const shouldFetch = !!participantId && !!periodId;

    return useQuery({
        queryKey: ["registration-step", participantId, periodId],
        queryFn: async () => {
            const { data } = await axiosClient.get<StepCheckResponse>(
                `/participants/${participantId}/registrations/check/${periodId}`
            );
            return data;
        },
        enabled: shouldFetch,
        staleTime: 1000 * 60 * 2,
    });
}
